import React, { FC, useEffect } from 'react';

import {
  type SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import Alert, { AlertSeverity } from '@rover/react-lib/src/components/notifications/Alert/Alert';
import type { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest/model/countryConfigurationUrls';
import { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import {
  BookingFeeLinkClickProfileEvent,
  SitterProfilePriceDisclaimerShownEvent,
} from './analyticsEvents';
import BannerContent from './BannerContent';

type VersionType = 'revamp' | 'legacy';

type SitterPriceBannerProps = {
  petCounts: SearchParamsPetCounts;
  petType?: SearchParamsPetType;
  serviceType?: string;
  countryConfigUrls?: CountryConfigurationUrls;
  bookingFeePercentage: string;
  services?: EnhancedPersonSitterProfileService[];
  version?: VersionType;
};

export const SitterPriceBanner: FC<SitterPriceBannerProps> = ({
  petCounts,
  petType,
  serviceType,
  countryConfigUrls,
  bookingFeePercentage,
  services,
  version = 'legacy',
}) => {
  useEffect(() => {
    // Emit “sitter-profile-price-disclaimer-shown” event on Banner render
    emitAnalyticsEvent(new SitterProfilePriceDisclaimerShownEvent());
  }, []);

  const handleBookingFeeClick = (): void => {
    emitAnalyticsEvent(new BookingFeeLinkClickProfileEvent());
  };

  return (
    <Alert
      severity={AlertSeverity.INFO}
      mb={version === 'revamp' ? '1x' : ['10x', '6x']}
      borderStyle="none"
      borderRadius="secondary"
      width="100%"
    >
      <BannerContent
        onBookingFeeClick={handleBookingFeeClick}
        bookingFeePercentage={bookingFeePercentage}
        countryConfigUrls={countryConfigUrls}
        petCounts={petCounts}
        petType={petType}
        serviceType={serviceType}
        services={services}
      />
    </Alert>
  );
};
